<template>
	<table-view :scrId="scrId"></table-view>
</template>

<script>
import TableView from '@qms/FreeForm/Content/Table/TableViewTwo.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { TableView }
};
</script>

<style></style>
